module.exports = __webpack_public_path__ + "static/media/ownership_wrong.d25ecfbb.png";